import { Link } from "react-router-dom";

const WORD = [
  { t: "Coloring", c: "#118AB2" },
  { t: "Books", c: "#06D6A0" },
  { t: "by", c: "#EF476F" },
  { t: "Wendy", c: "#F78C1F" },
];

export default function Logo({ className = "", onClick, testId = "brand-logo" }) {
  return (
    <Link
      to="/"
      onClick={onClick}
      data-testid={testId}
      className={`inline-flex flex-col leading-none ${className}`}
    >
      <span className="font-display text-2xl sm:text-3xl tracking-tight flex flex-wrap gap-x-1.5">
        {WORD.map((w) => (
          <span key={w.t} style={{ color: w.c }}>
            {w.t}
          </span>
        ))}
      </span>
      <span className="font-body text-[10px] sm:text-xs font-bold text-[#073B4C]/60 tracking-wide">
        Magic in every stroke!
      </span>
    </Link>
  );
}
